const getRecordColor = percentage =>
  percentage === 1 ? 'red' : `rgb(${255 * percentage},128,0)`;

export default getRecordColor;
